import React from "react";

export default function Campaigns({
  campaigns, campaignName, setCampaignName, campaignCost, setCampaignCost,
  addCampaign, searchedCampaignPerformance, handleFileUpload, downloadSampleCSV, inputClass,
  exportToCSV, exportToExcel
}) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Campaign Data</h2>
          <p className="text-slate-500 text-sm">Upload bulk campaigns via CSV or enter manually</p>
        </div>
        <div className="text-right">
          <button onClick={() => document.getElementById("camp-upload").click()} className="bg-white border border-slate-300 hover:bg-slate-50 text-slate-800 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">
            📤 Upload Campaigns
          </button>
          <input id="camp-upload" type="file" accept=".csv" onChange={(e) => handleFileUpload(e, "campaigns")} className="hidden" />
          <p onClick={() => downloadSampleCSV("campaigns")} className="text-blue-600 text-sm mt-2 cursor-pointer font-medium hover:underline">Download Sample CSV</p>
        </div>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h2 className="text-lg font-bold text-slate-800 mb-4">Add Campaign</h2>
        <div className="flex gap-4">
          <input type="text" placeholder="Campaign Name" value={campaignName} onChange={(e) => setCampaignName(e.target.value)} className={inputClass} />
          <input type="number" placeholder="Cost" value={campaignCost} onChange={(e) => setCampaignCost(e.target.value)} className={inputClass} />
        </div>
        <button onClick={addCampaign} className="mt-4 bg-slate-900 hover:bg-slate-800 text-white px-6 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">Add Campaign</button>
      </div>
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-slate-800">🎯 Campaign Performance</h2>
          <div className="flex gap-2">
            <button onClick={() => exportToCSV(searchedCampaignPerformance, "campaign_performance")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">CSV</button>
            <button onClick={() => exportToExcel(searchedCampaignPerformance, "campaign_performance")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">Excel</button>
          </div>
        </div>
        <div className="space-y-3">
          {searchedCampaignPerformance.map((c) => (
            <div key={c.id} className="flex flex-col md:flex-row md:items-center justify-between bg-white border border-slate-200 p-4 rounded-xl hover:border-blue-300 transition-all duration-200">
              <div>
                <span className="font-semibold text-slate-800">{c.name}</span>
                <div className="text-xs text-slate-500 mt-1 flex gap-2">
                  <span>Cost: ₹{c.cost}</span>
                  <span>• Leads: {c.leadsCount}</span>
                  <span>• Activated: {c.activatedCount}</span>
                </div>
              </div>
              <div className="flex flex-col items-end mt-2 md:mt-0">
                <span className="font-bold bg-slate-50 text-slate-800 px-3 py-1 rounded-lg text-sm border border-slate-100">
                  Rev: ₹{c.revenue} | Profit: <span className={c.profit >= 0 ? "text-emerald-600" : "text-red-600"}>₹{c.profit}</span> | ROI: {c.roi !== null ? `${c.roi}%` : <span className="text-slate-400 font-normal">No Spend Data</span>}
                </span>
                <div className="text-xs text-slate-500 mt-1 flex gap-2">
                  <span>CPL: ₹{c.costPerLead}</span>
                  <span>• CPA: ₹{c.costPerActivation}</span>
                  <span>• Conv: {c.conversionRate}%</span>
                </div>
              </div>
            </div>
          ))}
          {searchedCampaignPerformance.length === 0 && (
            <div className="p-4 text-center text-slate-400">No campaigns found.</div>
          )}
        </div>
      </div>
    </div>
  );
}